export default __webpack_public_path__ + "static/img47v-8247adeacb6511aedc4b28b70523815a.jpg";